<template>
  <v-card class="c-card d-flex flex-column">
    <v-skeleton-loader
      v-bind="attrs"
      class="c-post-skeleton pb-5"
      :types="{
        'post-heading': 'heading',
        'post-excerpt': 'paragraph',
        'post-action-bar': 'button, avatar@2'
      }"
      type="image, post-heading, post-excerpt, post-action-bar"
    />
  </v-card>
</template>

<script>
export default {
  name: 'PostCardSkeleton',

  components: {},

  data: function () {
    return {
      attrs: {
        elevation: 2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-card {
  height: 100%;
  max-width: min(400px, 100%);
  border-radius: 16px;
}

.c-post-skeleton {
  :deep(.v-skeleton-loader__post-heading) {
    margin-top: 16px;
    padding: 0 16px;
  }

  :deep(.v-skeleton-loader__post-excerpt) {
    margin-top: 16px;
    padding: 0 16px;
  }

  :deep(.v-skeleton-loader__post-action-bar) {
    margin-top: 16px;
    padding: 0 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
